/* eslint-disable indent */
// Application
import { useCallback, useEffect } from 'react'
import { useSnackbarContext } from 'redesign/context/snackbar'
import { snackbarErrorType, snackbarType } from 'redesign/typings/snackbar'

export const useSnackbar = () => {
    const {
        state: { snackbarProps, counterRetry },
        operations: { setSnackbarProps },
    } = useSnackbarContext()

    const onCloseSnackbar = useCallback(() => setSnackbarProps({ open: false }), [setSnackbarProps])

    useEffect(() => {
        let openTimeout: null | ReturnType<typeof setTimeout> = null
        if (snackbarProps.open && snackbarProps.duration) {
            openTimeout = setTimeout(() => {
                onCloseSnackbar()
            }, snackbarProps.duration)
        }

        return () => {
            if (openTimeout) {
                clearTimeout(openTimeout)
            }
        }
    }, [onCloseSnackbar, snackbarProps.duration, snackbarProps.open])

    const openSnackbar = ({ duration = 4000, variant = 'success', message, actionButton }: snackbarType) => {
        setSnackbarProps({ open: false })
        setSnackbarProps({
            open: true,
            duration,
            variant,
            message,
            actionButton,
        })
    }

    const openErrorSnackbarRetry = ({ message, onClick }: snackbarErrorType) => {
        const isCounterRetryThree = counterRetry.current < 3

        openSnackbar({
            variant: 'error',
            duration: isCounterRetryThree ? 60000 : 6000,
            message,
            actionButton: isCounterRetryThree
                ? {
                      onClick: () => {
                          counterRetry.current += 1
                          setSnackbarProps({ open: false })
                          onClick()
                      },
                      label: 'Repetir',
                  }
                : undefined,
        })

        if (counterRetry.current === 3) {
            counterRetry.current = 0
        }
    }

    return { snackbarProps, openSnackbar, openErrorSnackbarRetry, onCloseSnackbar }
}
